import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import CommonQuestions from './CommonQuestions';

function Home() {
  return (
    <>
      <section className="theme-light section m-0 p-0" data-theme="light">
        {/* Start flex container */}
        <div className='fullHeight is-flex is-flex-direction-column is-justify-content-start'>

            {/* Navigation */}
            <div className='columns is-flex is-flex-direction-rows is-justify-content-center'>
              <div className="m-0 p-0 column is-11"><Navigation /></div>
            </div>
            
            {/* Content */}
            <div className='pb-6 columns is-flex is-flex-direction-rows is-justify-content-center margin-homepage'>
              <div className="m-0 column is-8-fullhd is-8-widescreen is-10-desktop is-10-tablet is-10-mobile">
                <h1>Send. Schedule. Succeed.</h1>
                <h2>Nudgemail transforms boring emails into powerful, perfectly-timed reminders that keep you organized and rockin' throughout the day.</h2>
                <div className="my-5 is-flex is-flex-direction-row is-flex-wrap-wrap is-align-items-center">
                  <a href="/sign-up" className="mr-4 button">Start for free</a>
                  <a href="/features" className="textLinkBlack">Learn more</a>
                </div>
              </div>
            </div>
            
            {/* FAQ */}
            <div className='pt-6 columns is-flex is-flex-direction-rows is-justify-content-center main-content'>
                <div className="py-6 m-0 p-0 content column is-10-fullhd is-10-widescreen is-10-desktop is-10-tablet is-10-mobile">
                  <h2 className='pt-4 m-0 is-bold'>Common questions</h2>
                  <CommonQuestions />
                </div>
            </div>

            {/* Promo */}
            <div className='backgroundColorGrey border1 columns is-flex is-flex-direction-rows is-justify-content-center main-content'>
                <div className="py-6 m-0 p-0 content column is-8-fullhd is-8-widescreen is-8-desktop is-10-tablet is-10-mobile">
                  <h1 className='pt-4 m-0 is-bold'>Your inbox's secret weapon.</h1>
                  <h2 className='pt-1 m-0'>Your future self deserves a little nudge (or a firm shove). Nudgemail ditches the clunky apps and complicated tools for a ridiculously simple email reminder service that keeps you on track—no guilt trips required.</h2>
                  <div className="my-5 is-flex is-flex-direction-row is-flex-wrap-wrap is-align-items-center">
                    <a href="/sign-up" className="mr-4 button">Start for free</a>
                    <a href="/features" className="textLinkBlack">Learn more</a>
                  </div>
                </div>
            </div>
            
            {/* Footer */}
            <div className='footer m-0 p-0 columns is-flex is-flex-direction-rows is-justify-content-center is-align-items-center'>
              <div className="m-0 p-0 column is-11 is-10-mobile"><Footer /></div>
            </div>

        </div> 
        {/* End flex container */}
      </section>
    </>
  );
}

export default Home;